import React from 'react';
import loadable from '@loadable/component';
import { useDispatch } from 'react-redux';
import { useMount } from 'react-use';
import { createQuote, clearQuote } from 'store/quote/quoteActions';
import { clearPointsTiers } from 'store/pointsConversion/pointsConversionActions';
import { clearBooking } from 'store/booking/bookingActions';
import { resolveDeviceFingerprint } from 'store/userEnvironment/userEnvironmentActions';
import { setBookingClientRequestId, clearFormData } from 'store/checkout/checkoutActions';
import createBookingClientRequestId from 'lib/checkout/createBookingClientRequestId';

export const AsyncCheckoutLayout = loadable(() => import(/* webpackPrefetch: true */ './CheckoutLayout'));

const Checkout = (props) => {
  const dispatch = useDispatch();

  useMount(() => {
    dispatch(resolveDeviceFingerprint());

    //clientRequestId is sent to bookings api to prevent duplicate bookings. Reset after each booking is made;
    dispatch(setBookingClientRequestId(createBookingClientRequestId()));
  });

  return <AsyncCheckoutLayout {...props} />;
};

Checkout.activeSplits = ['qantas_travel_pass'];

Checkout.onEnterPage = ({ store }) => {
  store.dispatch(createQuote());
  store.dispatch(clearBooking());
};

Checkout.onExitPage = ({ store }) => {
  store.dispatch(clearQuote());
  store.dispatch(clearPointsTiers());
  store.dispatch(clearFormData());
};

export default Checkout;
